import React from 'react';

const InstagramPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fab fa-instagram"></i>
          Instagram - @marcodeman
        </h1>
        <p>Follow my visual journey through photos and stories on Instagram.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="social-content">
            <p className="welcome-text">
              Instagram is my visual storytelling platform where I share photos
              from family gatherings, travels, food, and the beautiful moments
              that make up our daily lives.
            </p>

            {/* Instagram Embed */}
            <div className="instagram-embed">
              <h3>Recent Posts</h3>
              <div className="social-embed-container">
                <blockquote 
                  className="instagram-media" 
                  data-instgrm-permalink="https://www.instagram.com/marcodeman/" 
                  data-instgrm-version="14"
                  style={{
                    background: '#FFF',
                    border: 0,
                    borderRadius: '3px',
                    boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                    margin: '1px',
                    maxWidth: '540px',
                    minWidth: '326px',
                    padding: 0,
                    width: '99.375%'
                  }}
                >
                </blockquote>
                <script async src="//www.instagram.com/embed.js"></script>
              </div>
            </div>

            {/* What to Expect */}
            <div className="content-preview">
              <h3>What You'll Find on My Instagram</h3>
              <div className="social-features">
                <div className="feature-item">
                  <i className="fas fa-camera-retro"></i>
                  <h4>Family Moments</h4>
                  <p>Beautiful photos from family gatherings, celebrations, and everyday life</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-utensils"></i>
                  <h4>Food & Cooking</h4>
                  <p>Italian recipes, family meals, and culinary traditions</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-map-marked-alt"></i>
                  <h4>Travel & Places</h4>
                  <p>Photos from travels, local spots, and meaningful locations</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-history"></i>
                  <h4>Heritage & Culture</h4>
                  <p>Visual stories about Italian heritage and family traditions</p>
                </div>
              </div>
            </div>

            {/* Direct Link */}
            <div className="social-link-section">
              <h3>Follow Me on Instagram</h3>
              <a 
                href="https://www.instagram.com/marcodeman/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-platform-link instagram-link"
              >
                <i className="fab fa-instagram"></i>
                Follow @marcodeman
              </a>
              <p className="link-description">
                Click above to follow me on Instagram and see my latest photos and stories.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstagramPage;